module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Bold.df390f1.woff";